<template>
    <div>
        <first />
        <second />
    </div>
</template>

<script src="./realEstate.js"></script>
<style src="./realEstate.css"></style>